import { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header, { headerHeight } from './Header';
import Sidebar from './Sidebar';

function MainLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    if (isDesktop) setMobileMenuOpen(false);
  }, [isDesktop]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Header
        menuOpen={mobileMenuOpen}
        onMenuToggle={() => setMobileMenuOpen((open) => !open)}
      />
      <Sidebar
        isDesktop={isDesktop}
        mobileOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: { xs: 2, sm: 3, lg: '28px 30px' },
          backgroundColor: '#f4f7fa',
          minHeight: '100vh',
          overflowX: 'hidden',
        }}
      >
        <Box aria-hidden="true" sx={{ height: headerHeight }} />
        <Outlet />
      </Box>
    </Box>
  );
}

export default MainLayout;
